export enum ROLE {
  User = "Personal",
  Commercial = "Commercial",
  Corporate = "Corporate",
  Employee = "Employee",
  ThirdParty = "ThirdParty",
  SystemAdmin = "Admin",
  Lawyers = "Lawyers",
}
